import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import DualExperience from "@/components/DualExperience";
import ProductShowcase from "@/components/ProductShowcase";
import FindYourPair from "@/components/FindYourPair";
import StorySection from "@/components/StorySection";
import Footer from "@/components/Footer";
import MissionVision from "@/components/MissionVision";

const LandingPage = () => {
  return (
    <div className="noise-overlay bg-[#050505] min-h-screen">
      <Navbar />
      <HeroSection />
      <DualExperience />
      <ProductShowcase />
      <FindYourPair />
      <StorySection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/mission-vision" element={<MissionVision />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
